export default __webpack_public_path__ + "static/media/Ballroll_00074.bf1c492a.png";